import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BoardSize from 'shared/components/parameters/BoardSize';
import InstantQuote from 'shared/components/parameters/InstantQuote';
import NumberLayer from 'shared/components/parameters/NumberLayer';
import Quantities from 'shared/components/parameters/Quantities';
import SilkscreenSides from 'shared/components/parameters/SilkscreenSides';
import SpecialInstructions from 'shared/components/parameters/SpecialInstructions';
import MaterialType from 'shared/components/parameters/MaterialType';
import FinishPlating from 'shared/components/parameters/FinishPlating';
import CopperWeight from 'shared/components/parameters/CopperWeight';
import { doQuote } from 'us_quickturn_prototype_pcb/pcb_fabrication/slice/thunks';
import { validator } from 'us_quickturn_prototype_pcb/pcb_fabrication/slice/validators';
import { START } from 'shared/data/quoteSteps';
import { selectFabricationDataForParameters } from 'us_quickturn_prototype_pcb/pcb_fabrication/slice/selectors';
import {
  materialTypeOptionsQuickturn,
  finishPlatingOptionsQuickturn,
  numberLayersQuickturn,
} from 'shared/data/selectOptions';
import {
  changeParameter,
  updateValidatorFlag,
} from 'us_quickturn_prototype_pcb/pcb_fabrication/slice/fabricationSlice';
import SolderMask from 'shared/components/parameters/SolderMask';
import SilkscreenColor from 'shared/components/parameters/SilkscreenColor';

const Parameters = () => {
  const dispatch = useDispatch();
  const {
    parameters,
    loading,
    quoteStep,
    // eslint-disable-next-line no-unused-vars
    validatorFlag,
  } = useSelector(selectFabricationDataForParameters);

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }));
  };

  const onQuoteRequest = () => {
    if (validator.allValid()) {
      validator.showMessages();
      dispatch(doQuote());
    } else {
      validator.showMessages();
      dispatch(updateValidatorFlag());
    }
  };

  const props = {
    parameters,
    onChangeParameter,
    disabled: loading,
  };

  return (
    <div>
      <div className="row mb-3">
        <div className="col-md-6">
          <h3 className="product-name">{Spree.productName}</h3>
        </div>
        <div className="col-md-6 instant-quote d-flex align-items-center">
          <InstantQuote
            loading={loading}
            onQuoteRequest={onQuoteRequest}
            label={
              quoteStep !== START
                ? Spree.translations.requote
                : Spree.translations.quote
            }
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Quantities
            {...props}
            required
            errorMessage={validator.message(
              'Quantity',
              parameters.quantities,
              'group_required|group_numeric|group_min:1,num|group_max:100,num',
            )}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <NumberLayer {...props} required options={numberLayersQuickturn} />
        </div>
        <div className="col-md-6">
          <BoardSize
            {...props}
            required
            errorMessageLength={validator.message(
              'Board Length',
              parameters.board_length,
              'required|numeric|min:0.25,num|max:20,num',
            )}
            errorMessageWidth={validator.message(
              'Board Width',
              parameters.board_width,
              'required|numeric|min:0.25,num|max:20,num',
            )}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <MaterialType
            {...props}
            locked
            options={materialTypeOptionsQuickturn}
          />
        </div>
        <div className="col-6">
          <FinishPlating
            {...props}
            className="text-nowrap"
            locked
            options={finishPlatingOptionsQuickturn}
          />
        </div>
      </div>
      <CopperWeight {...props} locked />
      <SolderMask {...props} locked />
      <div className="row">
        <div className="col-6">
          <SilkscreenSides {...props} />
        </div>
        <div className="col-6">
          <SilkscreenColor {...props} locked />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <SpecialInstructions
            {...props}
            errorMessage={validator.message(
              'Special Instructions',
              parameters.special_instructions,
              'max:255',
            )}
          />
        </div>
        <div className="col-12">
          <InstantQuote
            loading={loading}
            onQuoteRequest={onQuoteRequest}
            label={
              quoteStep !== START
                ? Spree.translations.requote
                : Spree.translations.quote
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Parameters;
